export default function getYear(date) {
  if (!date) {
    return 'N/A'
  }
  var year = new Date(date).getFullYear();

  return year ;
}


// WEBPACK FOOTER //
// ./src/app/filters/getYear.js